import React from 'react';

interface SubtitleProps {
  children: React.ReactNode | 'string';
}

export const Subtitle = ({ children }: SubtitleProps) => (
  <span className="text-[12px] leading-[16.8px] font-medium">{children}</span>
);
